import { UUID } from "crypto";
import type { PartnerFilters } from "../types";

/**
 * Partner query key factory
 */
export const partnerKeys = {
  all: ["partners"] as const,
  lists: () => [...partnerKeys.all, "list"] as const,
  list: (filters?: PartnerFilters) =>
    [...partnerKeys.lists(), filters || {}] as const,
  details: () => [...partnerKeys.all, "detail"] as const,
  detail: (id: UUID) => [...partnerKeys.details(), id] as const,
  // Partner contacts and addresses are read directly from Dexie via
  // `@stockline/web` reactive hooks — no TanStack cache key needed. Writes
  // go through the V2 push-batch in `usePartner{Address,Contact}Mutations`.
  // CRM Analytics keys
  statistics: (partnerId: UUID) =>
    [...partnerKeys.all, "statistics", partnerId] as const,
  productStats: (partnerId: UUID) =>
    [...partnerKeys.all, "product-stats", partnerId] as const,
  // Order history (recap pattern)
  orderHistory: (partnerId: UUID) =>
    [...partnerKeys.all, "order-history", partnerId] as const,
  // Partner Account (Financial) keys
  account: (partnerId: UUID) =>
    [...partnerKeys.all, "account", partnerId] as const,
} as const;
